<app-row-header (toggleMenu)="toggleMenu()">{{ 'FOOTER.contact' | translate }}</app-row-header>

@if (showMenuContent) {
    <address>
        <ul>
            <li>
                <p class="my-0">PZ Stelmach Sp. z o.o.</p>
                <p class="my-0">ul. Północna 22</p>
                <p class="my-0">45-805 Opole</p>
            </li>
            <li class="d-inline-flex flex-column mt-4">
                <span>{{ 'FOOTER.CONTACT.phone' | translate }}&nbsp;<a href="tel:+48775490100">+48 77 54 90 100</a></span>
            </li>
            <li class="mt-4">
                <a href="mailto:biuro@stelmach.pl">biuro&#64;stelmach.pl</a>
            </li>
        </ul>
    </address>
}
